<template>
  <div class="container" data-cy="not-found">
    <div v-if="!isSettings">
      <NotFound />
    </div>

    <div v-else class="not-found-background">
      <PageSettings :useslot="true">
        <NotFound />
      </PageSettings>
    </div>
  </div>
</template>

<script>
import NotFound from '@/common/components/NotFound.vue';
import PageSettings from '@/features/settings/pages/SettingsView.vue';

export default {
  metaInfo() {
    return {
      title: this.$t('components.pages.NotFound.headNotFound')
    };
  },
  components: {
    PageSettings,
    NotFound
  },
  computed: {
    isSettings() {
      return this.$route.path.startsWith('/settings');
    }
  }
};
</script>

<style lang="scss" scoped>
.ponycorn {
  max-width: 100%;
}
</style>
